import type { PolarModel } from "../../../lib/stageViewModels";
import { Empty } from "./McqBars";
import { useGrowIn } from "./useGrowIn";

export function PolarScale({ model }: { model: PolarModel }) {
  const { grown, reduced } = useGrowIn();
  if (model.total === 0) return <Empty />;
  const aWidth = grown ? model.a.pct : 50;
  return (
    <div className="flex flex-col h-full justify-center gap-10 text-rc-paper">
      <div className="grid grid-cols-2 gap-8">
        {[model.a, model.b].map((side, i) => (
          <div key={side.key} className={i === 0 ? "text-left" : "text-right"}>
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-rc-paper/55">{side.label}</div>
            <div className={`font-bold leading-none tabular-nums tracking-[-0.04em] mt-2 ${i === 0 ? "text-rc-berry" : "text-rc-paper"}`} style={{ fontSize: "clamp(3.5rem, 8vw, 7.5rem)" }}>{side.pct}%</div>
            <div className="text-[13px] text-rc-paper/50 tabular-nums mt-1">{side.count} Stimmen</div>
          </div>
        ))}
      </div>
      <div className="relative h-8 rounded-full bg-rc-paper/25 overflow-hidden" role="img" aria-label={`${model.a.label} ${model.a.pct} Prozent, ${model.b.label} ${model.b.pct} Prozent`}>
        <div className={`h-full bg-rc-berry ${reduced ? "" : "transition-[width] duration-700 ease-out"}`} style={{ width: `${aWidth}%` }} />
        <span aria-hidden className="absolute top-0 bottom-0 left-1/2 w-px bg-rc-ink/70" />
      </div>
    </div>
  );
}
